import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeScreenComponent } from './homeScreen/home-screen/home-screen.component';
import { SlideShowComponent } from './homeScreen/slide-show/slide-show.component';
import { HeaderComponent } from './master/header/header.component';
import { EventListComponent } from './homeScreen/event-list/event-list.component';
import { LeaderBoardComponent } from './homeScreen/leader-board/leader-board.component';
import { ContactSectionComponent } from './footer-section/contact-section.component';
import { MasterComponent } from './master/master.component';
import { ContactUsComponent } from './contactUs/contact-us/contact-us.component';
import { EventsPageComponent } from './eventsPages/events-page/events-page.component';
import { ErrorPageComponent } from './error/error-page/error-page.component';
import { AuthScreenComponent } from './authPage/auth-screen/auth-screen.component';
import { AuthInterceptor } from 'src/shared/services/auth-interseptor.service';
import { AuthGuardService } from 'src/shared/services/auth-guard.service';
import { VideoSectionComponent } from './homeScreen/video-section/video-section.component';
import { ProfileScreenComponent } from './profile-screen/profile-screen.component';
import { ProfileGuardService } from 'src/shared/services/profile-guard.service';
import { ClanScreenComponent } from './clan-screen/clan-screen.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClanDialogBoxComponent } from './profile-screen/clan-dialog-box/clan-dialog-box.component';
import { SquadDialogBoxComponent } from './eventsPages/events-page/squad-dialog-box/squad-dialog-box.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";

const appRoutes: Routes = [
  { path: '', component: HomeScreenComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'events', component: EventsPageComponent },
  { path: 'auth', component: AuthScreenComponent, canActivate: [AuthGuardService] },
  { path: 'profile', component: ProfileScreenComponent, canActivate: [ProfileGuardService] },
  { path: 'clan', component: ClanScreenComponent, canActivate: [ProfileGuardService] },
  { path: '**', component: ErrorPageComponent }


]
@NgModule({
  declarations: [
    AppComponent,
    HomeScreenComponent,
    SlideShowComponent,
    HeaderComponent,
    EventListComponent,
    LeaderBoardComponent,
    ContactSectionComponent,
    MasterComponent,
    ContactUsComponent,
    EventsPageComponent,
    ErrorPageComponent,
    AuthScreenComponent,
    VideoSectionComponent,
    ProfileScreenComponent,
    ClanScreenComponent,
    ClanDialogBoxComponent,
    SquadDialogBoxComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
    BrowserAnimationsModule,
    MatDialogModule,
    IvyCarouselModule,
    NgxSpinnerModule,
    ToastrModule.forRoot()

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
